export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7162.409eb0b1.jpg";